module.exports = __webpack_public_path__ + "static/media/wizualizacja-103.da729f0b.png";